import { apiDlUrl } from '@/environment/environment';

export const apiConstants = {
  fetchGuide: 'mock-data/analyze/guide.json',
  fetchTags: 'mock-data/tags.json',
  fetchArtefacts: 'mock-data/analyze/artefacts.json',
  fetchArtefact: 'mock-data/analyze/artefact.json',
  fetchArtifactUnit: 'mock-data/analyze/artefactUnit.json',
  fsm: apiDlUrl+'appfsmovers',
  sfm: apiDlUrl+'appfsmovers',
  ssm: apiDlUrl+'appfsmovers',
  dash: apiDlUrl+'appdash',
  alerts: apiDlUrl+'appsalealert',
  oos: apiDlUrl+'appoosalert',
  sst: apiDlUrl+'apptrendoall',
  cst: apiDlUrl+'apptrendoall',
  bst: apiDlUrl+'apptrendoall',
  csst: apiDlUrl+'apptrendoall',
  bsst: apiDlUrl+'apptrendoall'
  // sfm: apiDlUrl+'clifsmoversnew',
  // ssm: apiDlUrl+'clifsmoversnew',
  // dash: apiDlUrl+'clidashnew',
  // alerts: apiDlUrl+'clisalealertnew',
  // sst: apiDlUrl+'clitrendoallnew',
  // cst: apiDlUrl+'clitrendoallnew',
  // bst: apiDlUrl+'clitrendoallnew',
  // csst: apiDlUrl+'clitrendoallnew',
  // bsst: apiDlUrl+'clitrendoallnew'

  // fsm: 'mock-data/analyze/appfsmovers.json',
  // sfm: 'mock-data/analyze/clifsmoversnew.json',
  // ssm: 'mock-data/analyze/clifsmoversnew.json',
  // dash: 'mock-data/analyze/clidashnew.json',
  // alerts: 'mock-data/analyze/clisalealertnew.json',
  // sst: 'mock-data/analyze/clitrendoallnew.json',
  // cst: 'mock-data/analyze/clitrendoallnew.json',
  // bst: 'mock-data/analyze/clitrendoallnew.json',
  // csst: 'mock-data/analyze/clitrendoallnew.json',
  // bsst: 'mock-data/analyze/clitrendoallnew.json'
};
